(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.LeadClub",
            {
                url: "/LeadClub",
                component: "leadclub",
                PageTitle: "LeadClub",
                requiredPermissions: "LeadClub:View",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("leadclub",
    {
        templateUrl: "App/Resources/LeadClub/LeadClub.html",
        controller: leadClubCtrl,
        bindings: {
            states: "<"
        }
    });

    leadClubCtrl.$inject = ["$mdDialog", "$http", "$timeout", "$filter", "$scope", "$window", "purchaseApi", "eligibilityFormDialog", "surveys", "eligibilityFormApi", "permissionService", "wistiaApi"];

    function leadClubCtrl($mdDialog, $http, $timeout, $filter, $scope, $window, purchaseApi, eligibilityFormDialog, surveys, eligibilityFormApi, wistiaApi, permissionService) {
        var $ctrl = this;
 
        ng.extend($ctrl,
            {
                closeOtherAssets: closeOtherAssets,
                openDialog: openDialog               
            });

        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.leadClubId).then(function (response) {
                $ctrl.submitted = response;
            });
        });
   
        $ctrl.loadResources = function () {
            
            $ctrl.loadingAssets = true;
            wistiaApi.getLeadClubAssets().then(function (response) {

                var projectMedias = response.medias;
                $ctrl.Assets = [];

                var uniqueMedias = $filter("unique")(projectMedias, "section");
                ng.forEach(uniqueMedias, function (value, key) {
                    var newAsset =
                    {
                        Title: value.section,
                        Active: uniqueMedias.length > 1 ? true : false,
                        Medias: ($filter("filter")(projectMedias, { section: value.section }))
                    }
                    $ctrl.Assets.push(newAsset);
                });

            }).then($ctrl.loadingAssets = false);
        }

        function closeOtherAssets(asset) {
            ng.forEach($ctrl.Assets, function (a, key) {
                if (a.ID !== asset.ID)
                    a.Active = false;
            });
        }

        /*  Open the Enrollment Form  */
        function openDialog(event) {
         
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.leadClubId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }

        // Purchase Options Modal  
        $ctrl.openLeadClubPurchaseDialog = function (event) {
            
            $mdDialog.show({
                bindToController: true,
                controllerAs: "$ctrl",
                controller: dialogCtrl,
                templateUrl: "App/Resources/PurchasePage/template.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    orders: purchaseApi.getAllOrders(),
                    title: "Lead Club",
                    purchaseOptions: [{ Description: "1 Year Subscription - One-Time Payment", Amount: 3000 },
                                 { Description: "1 Year Subscription - 12 Monthly Payments", Frequency: "Monthly", Amount: 250, IsRecurringPayment: true }],
                    termsLink: "", //TODO: upload Terms,
                    marketingDollars: purchaseApi.getMarketingDollars().then(function (response) {                       
                        return response.MarketingDollarsTotal;
                    }).catch(ng.noop)
                }
            });
        }       
   
        $ctrl.openMediaBuyerPurchaseDialog = function (event) {

            $mdDialog.show({
                bindToController: true,
                controllerAs: "$ctrl",
                controller: dialogCtrl,
                templateUrl: "App/Resources/PurchasePage/template.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    orders: purchaseApi.getAllOrders(),
                    title: "Lead Club: Media Buyer",
                    purchaseOptions: [
                        { Description: "Media Buyer Package - One-Time Payment", Amount: 500 }
                    ],
                    termsLink: "", //TODO: upload Terms,                    
                    marketingDollars: purchaseApi.getMarketingDollars()
                        .then(function(response) {
                            return response.MarketingDollarsTotal;
                        }).catch(ng.noop)                    
                }
            });
        }

        if (permissionService.hasOnePermission("LeadClub:Access")) {
            $ctrl.loadResources();
        }   
    }

    dialogCtrl.$inject = ["$mdDialog", "purchaseApi", "$window"];
    function dialogCtrl($mdDialog, purchaseApi, $window) {
        var $ctrl = this;

        ng.extend($ctrl,
        {
            close: close,
            purchase: purchase,
            getPaymentAmount: getPaymentAmount,
            setup: setup
        });

        function setup() {
            $ctrl.selectedPurchaseOption = 0;
            $ctrl.paymentAmount = $ctrl.purchaseOptions[0].Amount;
            $ctrl.marketingDollarsToUse = 0;
        }

        $ctrl.setup();

        function getPaymentAmount() {
            if ($ctrl.marketingDollarsToUse > $ctrl.marketingDollars) {
                $ctrl.marketingDollarsToUse = $ctrl.marketingDollars;
            }
            if ($ctrl.marketingDollarsToUse > $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount) {
                $ctrl.marketingDollarsToUse = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount;
            }

            if ($ctrl.marketingDollarsToUse == null || $ctrl.marketingDollarsToUse < 0) {
                $ctrl.marketingDollarsToUse = 0;
            }

            $ctrl.paymentAmount = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount - $ctrl.marketingDollarsToUse;
        }  

        function purchase(model) {
            $ctrl.submittingOrder = true;
            $ctrl.error = false;
            var order = { Description: model.Description };
            order.PaymentAmount = $ctrl.paymentAmount;
            order.MarketingDollarsUsed = $ctrl.marketingDollarsToUse;
            order.MarketingStrategy = "LeadClub";
            console.log(order);
            if (!!$ctrl.selectedClassDate)
                order.Description = $ctrl.title + " - " + order.Description + "- Class: " + ($ctrl.purchaseOptions[$ctrl.selectedPurchaseOption].ClassDates[$ctrl.selectedClassDate]);
            if (!!$ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].IsRecurringPayment)
                order.Frequency = 3;
            else
                order.Frequency = 0;
          
            return purchaseApi.purchase(order)
                .then(function (response) {
                    
                    //$window.open(response, "_blank");
                    $window.location.href = response;
                    return response;
                }).catch(function (error) {
                    console.log(error);
                    $ctrl.submittingOrder = false;
                    $ctrl.error = true;
                });
        }

        function close() {
            $mdDialog.cancel();
        }
    };


})(window.app, window.angular); // jshint ignore:line